<template>
  <b-form @submit.prevent="$emit('submit')">
    <b-form-group label="Descripción">
      <b-form-input v-model="complejidadProyecto.descripcion" required type="text" placeholder="Descripción" />
    </b-form-group>
    <b-row>
      <b-col md="2">
        <b-form-group label="Factor de corrección">
          <b-form-input
            v-model="complejidadProyecto.factorCorreccion"
            required
            min="1"
            max="100"
            step="0.01"
            type="number"
            maxlength="6"
            placeholder="1"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <botonera-edicion url-cancelar="/complejidadesProyecto" />
  </b-form>
</template>
<script>
export default {
  props: {
    complejidadProyecto: Object,
  },
};
</script>
